import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Properties } from 'src/app/app-config/properties';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { Observable, lastValueFrom, throwError } from 'rxjs';
import { USERROLE } from 'src/util/constant';

@Injectable({
  providedIn: 'root',
})
export class DeviceManagementService {
  constructor(
    private http: HttpClient,
  ) { }

  isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent);
  }
  
}
